if (!customElements.get('product-cross-links')) {
  customElements.define(
    'product-cross-links',
    class ProductCrossLinks extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId; // Initialize with the default variant ID
        this.crossSellLinks = this.querySelectorAll('li[data-month]'); // Grab cross-sell links
      }

      variantIdChangedUnsubscriber = undefined;

      connectedCallback() {
        // Subscribe to variant changes on the product page
        this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          console.log('Variant changed:', event.data.variant); // Debug log
          const currentVariant = event.data.variant;

          this.variantId = currentVariant.id.toString(); // Update internal variant ID
          this.updateCrossSellLinks(currentVariant); // Update cross-sell links based on the current variant
        });

        // Initial update for the default variant
        const initialColor = this.dataset.defaultColor || ''; // Get the default color if available
        this.updateCrossSellLinks(initialColor);
        console.log('Initial color:', initialColor);
      }

      disconnectedCallback() {
        if (this.variantIdChangedUnsubscriber) {
          this.variantIdChangedUnsubscriber(); // Unsubscribe from the event
        }
      }

      async updateCrossSellLinks(currentVariant) {
        const localePrefix = document.documentElement.lang ? `/${document.documentElement.lang}` : ''; // Get the current language code
        this.crossSellLinks.forEach(async link => {
          const productHandle = link.dataset.productHandle; // Use `data-product-handle`

          if (productHandle) {
            try {
              const product = await fetch(`${localePrefix}/products/${productHandle}.js`).then(res =>
                res.json()
              );

              // First try to match both options if they exist
              let matchingVariant = product.variants.find(
                v =>
                  v.option1 === currentVariant.option1 &&
                  (currentVariant.option2 ? v.option2 === currentVariant.option2 : true)
              );

              // If no match found, try matching just option1 only
              if (!matchingVariant) {
                matchingVariant = product.variants.find(v => v.option1 === currentVariant.option1);
              }

              const anchor = link.querySelector('a');
              const productUrl = product.url.startsWith(localePrefix)
                ? product.url
                : `${localePrefix}${product.url}`; // Ensure no duplicate prefixes

              if (matchingVariant) {
                anchor.href = `${productUrl}?variant=${matchingVariant.id}`;
                link.addEventListener('click', event => {
                  console.log('clicked');
                  event.preventDefault();
                  window.location.href = anchor.href;
                });
              } else {
                anchor.href = productUrl;
              }
            } catch (error) {
              console.error(`Failed to fetch product for handle: ${productHandle}`, error);
            }
          }
        });
      }
    }
  );
}
